import Vue from 'vue'
import App from './App.vue'
import jQuery from 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import VueRouter from 'vue-router'
import { routes} from './routes'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { ModalPlugin } from 'bootstrap-vue'
import { PaginationNavPlugin } from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'


Vue.use(PaginationNavPlugin)
Vue.use(ModalPlugin)
Vue.use(VueSweetalert2)

Vue.use(VueRouter, axios, VueAxios)

axios.defaults.baseURL = 'https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.token


const router = new VueRouter ({
  routes
})

global.jQuery = jQuery;
global.$ = jQuery;

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
  axios,
}).$mount('#app')
